<template>
  <div>
    <mensaje-sistema></mensaje-sistema>
    <v-row>
      <v-col class="d-flex justify-center align-center">
        <ag-grid-vue class="ag-theme-balham" :style="{ width: '90%', height: '25vh' }" :columnDefs="columnDefs"
          :rowData="rowData" :localeText="localeTextSpanish" :gridOptions="gridOptions" @cell-clicked="onCellClicked"
          @grid-ready="onGridReadyFirstTable">
        </ag-grid-vue>
      </v-col>
    </v-row>

    <ComunDialogComp v-model="mostrarModal" persistent max-width="1400" :title="title" @close-modal="closeModal">
      <template v-slot:body>
        <v-form>
          <v-row>
            <v-col cols="12" md="8" class="d-flex horario-container flex-column align-end">
              <div v-for="(horario, index) in horariosAcademicos" :key="index" class="w-100 mb-2">
                <h3>Turno: {{ horario.turno_descripcion }}</h3>
                <ag-grid-vue class="horario-container ag-theme-balham" :key="tableKey"
                  :style="{ width: '90%', height: '22vh' }" :rowHeight="25" :columnDefs="columnDefs2"
                  :rowData="rowData2[index]" :localeText="localeTextSpanish" row-selection="multiple"
                  :suppressRowClickSelection="true" :getRowId="getRowId" :gridOptions="gridOptionsSecondTable[index]"
                  @row-selected="(event) => onRowSelected(event, index)" @cell-value-changed="onCellValueChanged"
                  @selection-changed="(event) => onSelectionChanged(event, index)
                    " @grid-ready="(params) => onGridReadySecondTable(params, index)
                    "></ag-grid-vue>
              </div>
            </v-col>

            <v-col cols="12" md="3">
              <v-row dense>
                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold">Cantidad de horas acádemicas = </v-card-text>
                  <v-text-field v-model="cantidad" solo style="max-width: 80px" hide-details class="small"
                    @input="updateValues('cantidad')"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold">Atención a padres de familia = </v-card-text>
                  <v-text-field v-model="hora_atencion" solo style="max-width: 80px" hide-details class="small"
                    @input="updateValues('hora_atencion')"></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold width: '100%'">Hora colegiado = </v-card-text>
                  <v-text-field v-model="hora_colegiado" solo style="max-width: 80px" hide-details class="small" :disabled="true" 
                  @input="updateValues('hora_colegiado')"></v-text-field>
                </v-col>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Por favor seleccione la hora y el día
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-select v-model="hora1" :items="clasesFiltradas" label="Hora" item-value="hora" return-object
                            item-text="hora" @change="onSelectHora(1, $event)"></v-select>
                        </v-col>
                        <v-col>
                          <v-select v-model="dia1" :items="nombresDiasHabiles" label="Día" item-value="id" return-object
                            item-text="nombre_dia" @change="onSelectDia(1, $event)"></v-select>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-select v-model="hora2" :items="clasesFiltradas" label="Hora" item-value="hora" return-object 
                            item-text="hora"  @change="onSelectHora(2, $event)"></v-select>
                        </v-col>
                        <v-col>
                          <v-select v-model="dia2" :items="nombresDiasHabiles" item-value="id" item-text="nombre_dia" return-object
                            label="Día" @change="onSelectDia(2, $event)"></v-select>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-select v-model="hora3" :items="clasesFiltradas" label="Hora" item-value="hora" return-object
                            item-text="hora" @change="onSelectHora(3, $event)"></v-select>
                        </v-col>
                        <v-col>
                          <v-select v-model="dia3" :items="nombresDiasHabiles" item-value="id" item-text="nombre_dia" return-object
                            label="Día" @change="onSelectDia(3, $event)"></v-select>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold">Hora coordinación:</v-card-text>
                  <v-text-field v-model="hora_coordinacion" solo style="max-width: 80px" hide-details class="small"
                    @input="updateValues('hora_coordinacion')"></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold">Horas Libres:</v-card-text>
                  <v-text-field v-model="hora_libre" solo style="max-width: 80px" hide-details class="small"
                    @input="updateValues('hora_libre')"></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold">Tutorias:</v-card-text>
                  <v-text-field v-model="hora_tutoria" solo style="max-width: 80px" hide-details class="small"
                    @input="updateValues('hora_tutoria')"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex align-center justify-start">
                  <v-card-text class="font-weight-bold">Total horas asignadas:</v-card-text>
                  <v-text-field v-model="horas_totales" solo style="max-width: 80px" hide-details class="small"
                    readonly></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex justify-end gap-10px mt-15">
                  <TableButtonCompVue normalButton @click="saveToDatabase" iconBut="fas fa-check"
                    text-button="Guardar" />
                  <TableButtonCompVue normalButton @click="closeModal" classColor="red" text-button="Cancelar" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <template>
            <v-row dense> </v-row>
          </template>
        </v-form>
      </template>
    </ComunDialogComp>
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import TableButtonCompVue from "../../../../components/ComponentsEst/TableButtonComp";
import ComunDialogComp from "../../../../../src/components/ComponentsEst/ComunDialogComp.vue";
import MensajeSistema from "../../../../components/mensajeSistema.vue";
import CheckboxRenderer from "./CheckboxRenderer.vue";

export default {
  name: "Clase",
  components: {
    AgGridVue,
    ComunDialogComp,
    MensajeSistema,
    TableButtonCompVue,
    // eslint-disable-next-line vue/no-unused-components
    CheckboxRenderer,
  },
  props: {
    id_nivel: {
      type: [String, Number],
      required: false,
    },
    cursosActualizados: {
      type: Array,
      default: () => [],
    },
    todosLosHorarios: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      //variables generales
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      turnos: [],
      id_turno: "",
      validIdNivel: null,
      //variables primera tabla
      nombre_apellido: "",
      tipo_docente: "",
      tiempo_libre: "",
      cantidad: "",
      id_nivel_docente: "",
      horarioDocente: [],
      hora_atencion: "0",
      hora_tutoria: "0",
      hora_colegiado: 3,
      hora_coordinacion: "0",
      hora_libre: "",
      horas_totales: "0",
      id_personales: "",
      id_persona: "",
      //ag-grid primera tabla inicio
      columnDefs: [
        {
          headerName: "Nombre y apellido",
          field: "nombre_apellido",
          width: 300,
        },
        {
          headerName: "Cantidad de horas academica",
          field: "cantidad",
          width: 250,
        },
        { headerName: "Tipo de docente", field: "tipo_docente", width: 250 },
        { headerName: "Estado", field: "registro", width: 250 },
        {
          headerName: "Editar",
          cellRenderer: this.iconCellRenderer,
          width: 250,
        },
      ],
      rowData: [{ registro: true }, { registro: false }],
      mostrarModal: false,
      gridApi: null,
      gridApisFirstTable: null,
      gridColumnApi: null,
      columnDefs2: [],
      rowData2: [],
      localeTextSpanish: {
        noRowsToShow: "No hay datos para mostrar",
      },
      gridOptionsSecondTable: [],
      gridApisSecondTable: [],

      registro: false,

      gridColumnApi2: null,
      griApi2: null,
      gridOptions: [
        { rowData: [], columnDefs: [] },
        { rowData: [], columnDefs: [] },
        { rowData: [], columnDefs: [] },
      ],
      diasSemanas: [],
      diasHabiles: [],
      horasDisponibles: [],
      errorMensaje: false,
      nombresDiasHabiles: [],
      //variables para el horario
      duracionMinutos: "",
      primeraHora: "",
      horaEntrada: "",
      horaSalida: "",
      horaInicioRecreo: "",
      horaInicioRecreo2: "",
      nombre_recreo: "",
      nombre_recreo2: "",
      //variables para la segunda tabla
      horariosAcademicos: [],
      editedData: [],
      selectedCells: [],
      disponibilidad: [],
      selectedRows: [],
      tableKey: 0,
      hora1: "",
      hora2: "",
      hora3: "",
      dia1: "",
      dia2: "",
      dia3: "",
      hora_inicio1: null,
      hora_fin1: null,
      hora_inicio2: null,
      hora_fin2: null,
      hora_inicio3: null,
      hora_fin3: null,
      horaConcatenada1:null,
      horaConcatenada2:null,
      horaConcatenada3:null,
      horaColegiado:[],
      clasesFiltradas: [],
      disponibilidadFiltrada :[],
      disponibilidad_total:[],
      item:[],
    };
  },
  mounted() {
    if (this.checkIdNivel()) {
      this.initializeData();
      this.horariosAcademicos.forEach((horario, index) => {
        this.gridOptionsSecondTable[index] = {};
      });
    }
    this.filtrarClases();

  },
  watch: {
    cursosActualizados: {
      handler() {
        if (this.checkIdNivel()) {
          this.getDocentes();
          this.initializeData();
        }
      },
      deep: true,
      immediate: true,
    },
    id_nivel(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.checkIdNivel()) {
          this.initializeData();
          this.getDocentes();
          this.horariosAcademicos.forEach((horario, index) => {
            this.gridOptionsSecondTable[index] = {};
          });
        }
      }
    },
  },
  computed: {
    title() {
      return `Editar docente: ${this.nombre_apellido}.`;
    },
  },
  methods: {
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    checkIdNivel() {
      try {
        if (!this.id_nivel || this.id_nivel === "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Debe seleccionar un nivel`,
            tiempo: null,
          });
          return false;
        } else {
          this.setEnviarMens({
            tipo: "S",
            mensaje: `Nivel seleccionado satisfactoriamente`,
            tiempo: null,
          });
          return true;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Ha ocurrido un error inesperado`,
          tiempo: null,
        });
        return false;
      }
    },
    async getDocentes() {
      try {
        const response = await axios.get(
          `/horario/horarioClase/${this.id_nivel}/${this.id_colegio}/`
        );
       
        this.rowData = response.data.data.map((item) => {
          return {
            nombre_apellido: `${item.nombre_persona} ${item.ape1_persona} ${item.ape2_persona}`,
            cantidad:item.cantidad_horaacademica - this.hora_colegiado,
            hora_colegiado: item.hora_colegiado,
            tipo_docente: item.desc_tipo_docente,
            nombre_persona: item.nombre_persona,
            ape1_persona: item.ape1_persona,
            ape2_persona: item.ape2_persona,
            id_nivel: item.id_nivel_docente,
            id_personales: item.id_personales,
            id_persona: item.id_persona,
            id_tipo_docente: item.tipo_docente,
            id_area: item.id_areas_docente,
          };
        });
        this.getHorarioDocente();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //metodo que inicializa ag-grid 1ra tabla
    onGridReadyFirstTable(params) {
      this.gridApisFirstTable = params.api;
      this.gridColumnApiFirstTable = params.columnApi;
    },

    async initializeData() {
      try {
        await Promise.all([
          this.getDiasDeLaSemana(),
          this.getTurnos(),
          this.getHorarioAcademico(),
          this.cargarDatosYObtenerDiasHabiles(),
        ]);
        await this.getDocentes();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getHorarioDocente() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_area: this.id_area,
        id_nivel: this.id_nivel,
        id_persona: this.id_persona,
      };

      try {
        let response = await axios.get("/horario/horarioClase", { params });
        this.horarioDocente = response.data.data;
        this.updateRowData();
      } catch (error) {
        throw error;
      }
    },

    async getHorarioHoraColegiado(id_personales){
      let params= {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_nivel: this.id_nivel,
        id_personal: id_personales,
      };

      try {
        let response = await axios.get("/horario/horarioClase/horaColegiado", {params})
        this.horaColegiado = response.data.data;

        this.hora1 = this.horaColegiado[0].hora;
        this.hora2 = this.horaColegiado[1].hora;
        this.hora3 = this.horaColegiado[2].hora;
        this.dia1 = this.horaColegiado[0].id_dia;
        this.dia2 = this.horaColegiado[1].id_dia;
        this.dia3 = this.horaColegiado[2].id_dia;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", tiempo: null });
      }

    },

    updateRowData() {
      this.rowData = this.rowData.map((item) => {
        const horarioDocenteItem = this.horarioDocente.find(
          (horario) => horario.id_persona === item.id_persona
        );
         
      
   
    if (horarioDocenteItem) {
      // Actualizamos las propiedades existentes
      item.registro = horarioDocenteItem.registro;
      item.cantidad = horarioDocenteItem.cantidad;
      item.disponibilidad = horarioDocenteItem.disponibilidad;
      item.hora_atencion = horarioDocenteItem.hora_atencion;
      item.hora_coordinacion = horarioDocenteItem.hora_coordinacion;
      item.hora_libre = horarioDocenteItem.hora_libre;
      item.hora_tutoria = horarioDocenteItem.hora_tutoria;
      item.horas_totales = horarioDocenteItem.horas_totales;
      item.disponibilidad_total = horarioDocenteItem.disponibilidad_total;
      
       if (this.hora1) item.hora1 = this.hora1;
       if (this.hora2) item.hora2 = this.hora2;
       if (this.hora3) item.hora3 = this.hora3;
      
      if (this.dia1) item.dia1 = this.dia1;
      if (this.dia2) item.dia2 = this.dia2;
      if (this.dia3) item.dia3 = this.dia3;
    }
    
    return item;
    
  });
},

    onGridReadySecondTable(params, index) {
      this.gridApisSecondTable[index] = params.api;
    },
    updateRowData2WithDisponibilidad(index) {
      if (
        !this.disponibilidad ||
        !this.disponibilidad.length ||
        !this.rowData2[index]
      ) {
        return;
      }

      this.disponibilidad.forEach((disponible) => {
        const dia = disponible.dia.toLowerCase();
        this.rowData2[index].forEach((row) => {
          if (disponible.hora === row.hora) {
            row[dia] = disponible.disponible;
          }
        });
      });

      // Refrescar los datos de la tabla en ag-Grid para el índice
      if (this.gridApisSecondTable[index]) {
        this.gridApisSecondTable[index].setRowData(this.rowData2[index]);
        this.gridApisSecondTable[index].refreshCells({ force: true });
      }
    },

    iconCellRenderer(params) {
      const isTrue = params.data.registro;
      const iconElement = document.createElement("i");
      iconElement.className = "fa fa-solid fa-pen";
      if (isTrue) {
        iconElement.classList.add("icon-blue");
      }
      return iconElement;
    },

    onCellClicked(event) {
      this.resetFields();
      this.id_personales = event.data.id_personales;
      //this.getHorarioHoraColegiado(this.id_personales);
      if (event.data.registro === true ) {
            this.getHorarioHoraColegiado(event.data.id_personales)
        }

      if (event.event.target.classList.contains("fa-pen") ) {
        this.mostrarModal = true;
        this.nombre_apellido = event.data.nombre_apellido;
        this.cantidad = event.data.cantidad;
        this.tipo_docente = event.data.tipo_docente;
        this.id_persona = event.data.id_persona;
        this.id_tipo_docente = event.data.id_tipo_docente;
        this.id_area = event.data.id_area;
        this.disponibilidad = event.data.disponibilidad;
        this.hora_atencion = event.data.hora_atencion;
        this.hora_coordinacion = event.data.hora_coordinacion;
        this.hora_libre = event.data.hora_libre;
        this.hora_tutoria = event.data.hora_tutoria;
        this.horas_totales = event.data.horas_totales;
        this.disponibilidad_total = event.data.disponibilidad_total;
        // eslint-disable-next-line no-undef
        if (this.hora1) item.hora1 = this.hora1;
      // eslint-disable-next-line no-undef
      if (this.hora2) item.hora2 = this.hora2;
      // eslint-disable-next-line no-undef
      if (this.hora3) item.hora3 = this.hora3;
      
      // eslint-disable-next-line no-undef
      if (this.dia1) item.dia1 = this.dia1;
      // eslint-disable-next-line no-undef
      if (this.dia2) item.dia2 = this.dia2;
      // eslint-disable-next-line no-undef
      if (this.dia3) item.dia3 = this.dia3;
      }
      this.horariosAcademicos.forEach((horario, index) => {
        this.updateRowData2WithDisponibilidad(index);
      });
    },

    resetFields() {
      // Limpiar todos los campos de datos del formulario
      this.disponibilidad = [];
      this.nombre_apellido = "";
      this.cantidad = "";
      this.tipo_docente = "";
      this.id_persona = "";
      this.id_personales = "";
      this.id_tipo_docente = "";
      this.id_area = "";
      this.hora1="",
      this.hora2="",
      this.hora3="",
      this.dia1="",
      this.dia2="",
      this.dia3="",

      // Limpiar los datos de la tabla
      this.rowData2.forEach((rowArray) => {
        rowArray.forEach((row) => {
          // Reiniciar todos los campos de días a 'false'
          this.nombresDiasHabiles.forEach((dia) => {
            row[dia.nombre_dia.toLowerCase()] = false; // Desmarcar los checkboxes
          });

          row.disponible = false; // Reiniciar la disponibilidad de la fila
        });
      });

      // Actualizar la referencia de rowData2 para asegurarnos de que Vue detecte el cambio
      this.rowData2 = [...this.rowData2];

      this.tableKey += 1;
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    closeModal() {
      //this.initializeData();
      this.resetFields();
      this.mostrarModal = false;
    },
    onSelectHora(index, selectedItem) {
      // Según el índice, almacena la hora de inicio y fin en la variable correspondiente
      if (index === 1) {
        this.hora_inicio1 = selectedItem.horaInicio;
        this.hora_fin1 = selectedItem.horaFin;
        this.horaConcatenada1 = selectedItem.hora;
      } else if (index === 2) {
        this.hora_inicio2 = selectedItem.horaInicio;
        this.hora_fin2 = selectedItem.horaFin;
        this.horaConcatenada2 = selectedItem.hora;
      } else if (index === 3) {
        this.hora_inicio3 = selectedItem.horaInicio;
        this.hora_fin3 = selectedItem.horaFin;
        this.horaConcatenada3 = selectedItem.hora;
      }
    },

    onSelectDia(index, selectedItem) {
      // Según el índice, almacena el id del día en la variable correspondiente
      if (index === 1) {
        this.dia1 = selectedItem.id;
      } else if (index === 2) {
        this.dia2 = selectedItem.id;
      } else if (index === 3) {
        this.dia3 = selectedItem.id;
      }
    },

    excluirDisponibilidad() {
 
  const disponibilidadFuente = (this.disponibilidad_total && this.disponibilidad_total.length > 0)
    ? this.disponibilidad_total
    : (this.disponibilidad && this.disponibilidad.length > 0)
      ? this.disponibilidad
      : []; 


  const normalizeHora = hora => (hora ? hora.replace(/\s+/g, '').trim() : '');

  // Filtrar la disponibilidad si existen datos en la fuente seleccionada
  this.disponibilidadFiltrada = disponibilidadFuente.filter(item => 
    !(item.id === Number(this.dia1) && normalizeHora(item.horaInicio) === normalizeHora(this.hora_inicio1)) &&
    !(item.id === Number(this.dia2) && normalizeHora(item.horaInicio) === normalizeHora(this.hora_inicio2)) &&
    !(item.id === Number(this.dia3) && normalizeHora(item.horaInicio) === normalizeHora(this.hora_inicio3))
  );
},

    async saveToDatabase() {
      this.excluirDisponibilidad();
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        hora_tutoria: this.hora_tutoria,
        hora_atencion: this.hora_atencion,
        hora_colegiado : this.hora_colegiado,
        hora_coordinacion : this.hora_coordinacion,
        hora_libre : this.hora_libre,
        horas_totales: this.horas_totales,
        id_turno: this.id_turno,
        id_nivel: this.id_nivel,
        cantidad: this.cantidad,
        nombre_apellidos: this.nombre_apellido,
        desc_tipo_docente: this.tipo_docente,
        id_persona: this.id_persona,
        id_personales: this.id_personales,
        id_area: this.id_area,
        disponibilidad: this.disponibilidadFiltrada,
        dia1: this.dia1,
        dia2 : this.dia2,
        dia3 : this.dia3,
        hora_inicio1: this.hora_inicio1,
        hora_fin1: this.hora_fin1,
        hora_inicio2: this.hora_inicio2,
        hora_fin2: this.hora_fin2,
        hora_inicio3: this.hora_inicio3,
        hora_fin3: this.hora_fin3,
        horaConcatenada1: this.horaConcatenada1,
        horaConcatenada2: this.horaConcatenada2,
        horaConcatenada3: this.horaConcatenada3,
        disponibilidad_total: this.disponibilidad
      };
      try {
        // Guardar en la base de datos
        // eslint-disable-next-line no-unused-vars
        const response = await axios.post(`/horario/horarioClase/`, { params });
        this.closeModal();
        this.getDocentes();
        this.resetFields();
        await this.initializeData();
         this.getHorarioDocente();
        // this.getHorarioHoraColegiado(); 
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getTurnos() {
      try {
        let response = await axios.get("/mantenimiento/turnos");
        this.turnos = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async getDiasHabiles() {
      let id_colegio = sessionStorage.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${id_colegio}`
        );
        this.diasHabiles = response.data[0].dias_seleccionados;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");
        this.diasSemanas = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async cargarDatosYObtenerDiasHabiles() {
      try {
        await Promise.all([this.getDiasHabiles(), this.getDiasDeLaSemana()]);
        this.obtenerNombresDiasHabiles();
        this.actualizarColumnas();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    actualizarColumnas() {
      if (!Array.isArray(this.nombresDiasHabiles)) {
        return;
      }

      const columnasDinamicas2 = [
        { field: "hora", headerName: "Hora", pinned: "left", width: 100 },
        {
          headerName: "",
          // // Checkbox en el header para seleccionar/deseleccionar todas las filas
          checkboxSelection: true,
          pinned: "left",
          width: 40,
        },
      ];

      this.nombresDiasHabiles.forEach((dia) => {
        columnasDinamicas2.push({
          headerName: dia.nombre_dia,
          field: dia.nombre_dia.toLowerCase(),
          cellRenderer: "CheckboxRenderer",
          cellRendererParams: {
            onClick: (params) => this.onDayCheckboxChange(params, dia),
          },
          width: 50,
          flex: 4,
          lockPosition: true,
          suppressMenu: true,
          sortable: false,
          cellStyle: { textAlign: "center" },
        });
      });

      this.columnDefs2 = columnasDinamicas2;
      this.gridApisSecondTable.forEach((api) => {
        if (api) {
          api.setColumnDefs(this.columnDefs2);
        }
      });
    },

    obtenerNombresDiasHabiles() {
      if (!this.diasSemanas) {
        return [];
      }
      this.nombresDiasHabiles = this.diasSemanas
        .filter((diaSemana) => this.diasHabiles.includes(diaSemana.id))
        .map((diaHabil) => ({
          id: diaHabil.id,
          nombre_dia: diaHabil.nombre_dia,
        }));
      return this.nombresDiasHabiles;
    },

    // Datos del Horario
    async getHorarioAcademico() {
      try {
        let response = await axios.get(
          `/administrativo/horarioAcademico/${this.id_colegio}/${this.id_nivel}/`
        );
        this.horariosAcademicos = response.data.data;

        if (this.horariosAcademicos.length === 0) {
          this.horasDisponibles = [];
          return;
        }
        // Iterar sobre todos los horarios académicos obtenidos
        this.horariosAcademicos.forEach((horario, index) => {
          this.calcularHora(index);
          this.actualizarColumnas(index);
        });
      } catch (error) {
        this.horasDisponibles = [];
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    calcularHora(index) {
      this.asignarVariablesHorario(index);
      let horario = this.horariosAcademicos[index];
      let id_turno = this.horariosAcademicos[index].id_turno;
      let horasDisponibles = [];

      let horaInicio = horario.hora_entrada.split(":").slice(0, 2).join(":");
      let horaFin = horario.hora_salida.split(":").slice(0, 2).join(":");
      let horaInicioRecreo = horario.inicio_recreo1
        .split(":")
        .slice(0, 2)
        .join(":");
      let horaInicioRecreo2 = horario.inicio_recreo2
        .split(":")
        .slice(0, 2)
        .join(":");

      let primeraHora = parseInt(horario.hora_de_formacion.split(":")[1]);
      // eslint-disable-next-line no-unused-vars
      let duracionMinutos = parseInt(horario.duracion_hora_academica);

      // Tratamiento de la primera hora de formación
      if (primeraHora !== null && !isNaN(primeraHora)) {
        const horasPrimera = Math.floor(primeraHora / 60);
        const minutosPrimera = primeraHora % 60;
        let nuevaHoraInicio = new Date(
          2022,
          0,
          1,
          parseInt(horaInicio.split(":")[0]) + horasPrimera,
          parseInt(horaInicio.split(":")[1]) + minutosPrimera
        );
        let horaFinFormacion = `${nuevaHoraInicio
          .getHours()
          .toString()
          .padStart(2, "0")}:${nuevaHoraInicio
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

        if (horaInicio !== horaFinFormacion) {
          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinFormacion}`,
            tipo: "Formación",
            horaInicio,
            horaFin: horaFinFormacion,
            id_turno: id_turno,
          });
          horaInicio = horaFinFormacion;
        }
      }

      // Extraer horas, minutos y segundos de la duración
      let [horasDuracion, minutosDuracion, segundosDuracion] =
        this.duracionMinutos.split(":").map(Number);

      // Calcular la duración total en minutos
      let duracionTotalMinutos =
        horasDuracion * 60 + minutosDuracion + segundosDuracion / 60;

      while (horaInicio < horaFin) {
        let [hora, minuto] = horaInicio.split(":").map(Number);
        let inicio = new Date(2022, 0, 1, hora, minuto);

        // Manejo de los recreos
        if (horaInicio === horaInicioRecreo) {
          let [horas, minutos, segundos] = horario.tiempo_de_recreo
            .split(":")
            .map(Number);
          let tiempoRecreoEnMinutos = horas * 60 + minutos + segundos / 60;

          let inicioRecreo = new Date(
            2022,
            0,
            1,
            parseInt(horaInicio.split(":")[0]),
            parseInt(horaInicio.split(":")[1])
          );

          let finRecreo = new Date(
            inicioRecreo.getTime() + tiempoRecreoEnMinutos * 60000
          );
          let horaFinRecreo = `${finRecreo
            .getHours()
            .toString()
            .padStart(2, "0")}:${finRecreo
              .getMinutes()
              .toString()
              .padStart(2, "0")}`;

          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo}`,
            tipo: this.nombre_recreo,
            horaInicio,
            horaFin: horaFinRecreo,
            id_turno: id_turno,
          });

          horaInicio = horaFinRecreo;
          inicio = finRecreo;
        }

        if (horaInicio === horaInicioRecreo2) {
          let [horas, minutos, segundos] = horario.tiempo_de_recreo2
            .split(":")
            .map(Number);
          let tiempoRecreo2EnMinutos = horas * 60 + minutos + segundos / 60;

          let inicioRecreo2 = new Date(
            2022,
            0,
            1,
            parseInt(horaInicio.split(":")[0]),
            parseInt(horaInicio.split(":")[1])
          );

          let finRecreo2 = new Date(
            inicioRecreo2.getTime() + tiempoRecreo2EnMinutos * 60000
          );
          let horaFinRecreo2 = `${finRecreo2
            .getHours()
            .toString()
            .padStart(2, "0")}:${finRecreo2
              .getMinutes()
              .toString()
              .padStart(2, "0")}`;

          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo2}`,
            tipo: this.nombre_recreo2,
            horaInicio,
            horaFin: horaFinRecreo2,
            id_turno: id_turno,
          });

          horaInicio = horaFinRecreo2;
          inicio = finRecreo2;
        }

        let fin = new Date(inicio.getTime() + duracionTotalMinutos * 60000);
        let horasFin = fin.getHours().toString().padStart(2, "0");
        let minutosFin = fin.getMinutes().toString().padStart(2, "0");
        let nuevoInicio = `${horasFin}:${minutosFin}`;

        if (nuevoInicio > horaFin) break;

        horasDisponibles.push({
          hora: `${horaInicio} - ${nuevoInicio}`,
          tipo: "Clase",
          horaInicio,
          horaFin: nuevoInicio,
          id_turno: id_turno,
        });
        horaInicio = nuevoInicio;
      }
      this.rowData2[index] = horasDisponibles
        .filter((item) => item.tipo === "Clase")
        .map((item) => {
          let rowDataItem = {
            disponible: true,
            hora: item.hora,
            tipo: item.tipo,
            horaInicio: item.horaInicio,
            horaFin: item.horaFin,
            id: item.id,
            id_turno: item.id_turno,
          };
          return rowDataItem;
        });
    },
    // metodo de los checbox

    asignarVariablesHorario(index) {
      if (index >= this.horariosAcademicos.length) {
        return;
      }

      const horario = this.horariosAcademicos[index];
      // Asignar variables de instancia basadas en el horario específico
      this.duracionMinutos = horario.duracion_hora_academica;
      this.primeraHora = parseInt(horario.hora_de_formacion.split(":")[1]);
      this.horaEntrada = horario.hora_entrada;
      this.horaSalida = horario.hora_salida;
      this.horaInicioRecreo = horario.inicio_recreo1;
      this.duracionRecreo = parseInt(horario.tiempo_de_recreo.split(":")[1]);
      this.horaInicioRecreo2 = horario.inicio_recreo2;
      this.duracionRecreo2 = parseInt(horario.tiempo_de_recreo2.split(":")[1]);
      this.nombre_recreo = horario.titulo_recreo1;
      this.nombre_recreo2 = horario.titulo_recreo2;
    },
    getRowId(params) {
      return params.data.id + "-" + params.data.hora; // Combina id y hora para asegurar unicidad
    },

    // metodo de los checbox de fila
    onRowSelected(event, index) {
      const { data, node } = event;
      const isSelected = node.isSelected();
      // Dividir la hora para obtener horaInicio y horaFin
      const [horaInicio, horaFin] = data.hora.split(" - ");
      // Actualizar todos los campos de días con el valor de isSelected
      this.nombresDiasHabiles.forEach((dia) => {
        const field = dia.nombre_dia.toLowerCase();
        this.$set(data, field, isSelected);
        this.updateDisponibilidad({
          dia: dia.nombre_dia,
          id: dia.id,
          hora: data.hora,
          horaInicio: horaInicio,
          horaFin: horaFin,
          disponible: isSelected,
          tipo: data.tipo,
          id_turno: data.id_turno,
        });
      });

      const gridApi = this.gridApisSecondTable[index];
      if (gridApi) {
        gridApi.refreshCells({ rowNodes: [node], force: true });
      }
    },

    onDayCheckboxChange(params, dia) {
      const { node, data, column } = params;
      const field = dia.nombre_dia.toLowerCase();
      const newValue = !data[field];
      this.$set(data, field, newValue);

      if (column.colId === "selection") {
        this.nombresDiasHabiles.forEach((dia) => {
          const diaField = dia.nombre_dia.toLowerCase();
          this.$set(data, diaField, newValue);
          this.$set(data, `${diaField}_id`, dia.id);
        });
        node.setSelected(newValue);
      } else {
        const allSelected = this.nombresDiasHabiles.every(
          (dia) => data[dia.nombre_dia.toLowerCase()]
        );
        node.setSelected(allSelected);
      }

      // Dividir la hora para obtener horaInicio y horaFin
      const [horaInicio, horaFin] = data.hora.split(" - ");
      this.updateDisponibilidad({
        dia: dia.nombre_dia,
        id: dia.id,
        hora: data.hora,
        horaInicio: horaInicio,
        horaFin: horaFin,
        disponible: newValue,
        tipo: data.tipo,
        id_turno: data.id_turno,
      });

      params.api.refreshCells({ rowNodes: [node], force: true });
    },

    onCellValueChanged(event) {
      if (!event.data || !event.colDef.field) {
        return;
      }

      const dia = event.colDef.field;
      const disponible = event.data[dia];
      const hora = event.data.hora;
      const horaFin = event.data.horaFin;
      const horaInicio = event.data.horaInicio;

      if (!hora) {
        return;
      }

      this.updateDisponibilidad({
        dia: dia,
        id: event.data[`${dia}_id`],
        hora: hora,
        horaInicio: horaInicio,
        horaFin: horaFin,
        disponible: disponible,
        tipo: event.data.tipo,
        id_turno: event.data.id_turno,
      });
    },



    filtrarClases() {
      // Filtrar los horarios donde el tipo es "Clase"
      this.clasesFiltradas = this.todosLosHorarios.filter(horario => horario.tipo === "Clase");

    },


    updateDisponibilidad(disponibilidadItem) {
      if (!this.disponibilidad) {
        this.disponibilidad = [];
      }

      const index = this.disponibilidad.findIndex(
        (item) =>
          item.dia === disponibilidadItem.dia &&
          item.hora === disponibilidadItem.hora
      );

      if (index !== -1) {
        if (disponibilidadItem.disponible) {
          this.disponibilidad.splice(index, 1, disponibilidadItem); // Actualizar el elemento existente
        } else {
          this.disponibilidad.splice(index, 1); // Remover el elemento si ya no está disponible
        }
      } else if (disponibilidadItem.disponible) {
        this.disponibilidad.push(disponibilidadItem); // Agregar un nuevo elemento si está disponible
      }
    },

    // eslint-disable-next-line no-unused-vars
    onSelectionChanged(event) {
      // eslint-disable-next-line no-unused-vars
      this.gridApisSecondTable.forEach((gridApi, index) => {
        if (!gridApi) return;
        const selectedNodes = gridApi.getSelectedNodes();
        selectedNodes.forEach((node) => {
          const data = node.data;
          this.nombresDiasHabiles.forEach((dia) => {
            const field = dia.nombre_dia.toLowerCase();
            this.$set(data, field, true);
          });
        });
        gridApi.refreshCells({ force: true });
      });
    },

    // metodo para calcular la horas academica y hora de tutoria
    updateValues(field) {
  // Convertir las entradas a números enteros, si no son números válidos, asignar cero
  let cantidad = parseInt(this.cantidad) || 0;
  let horaAtencion = parseInt(this.hora_atencion) || 0;
  let horaTutoria = parseInt(this.hora_tutoria) || 0;
  let horaColegiado = parseInt(this.hora_colegiado) || 0;
  let horaCoordinacion = parseInt(this.hora_coordinacion) || 0;
  let horaLibre = parseInt(this.hora_libre) || 0;

  // Guardar los valores previos para la próxima actualización
  let prevHoraAtencion = this.prevHoraAtencion || 0;
  let prevHoraTutoria = this.prevHoraTutoria || 0;
  let prevHoraColegiado = this.prevHoraColegiado || 0;
  let prevHoraCoordinacion = this.prevHoraCoordinacion || 0;
  let prevHoraLibre = this.prevHoraLibre || 0;

  // Determinar la diferencia en el valor actual y el valor previo, y ajustar la cantidad
  if (field === "hora_atencion" && !isNaN(horaAtencion)) {
    cantidad -= horaAtencion - prevHoraAtencion;
    this.prevHoraAtencion = horaAtencion;
  } else if (field === "hora_tutoria" && !isNaN(horaTutoria)) {
    cantidad -= horaTutoria - prevHoraTutoria;
    this.prevHoraTutoria = horaTutoria;
  } else if (field === "hora_colegiado" && !isNaN(horaColegiado)) {
    cantidad -= horaColegiado - prevHoraColegiado;
    this.prevHoraColegiado = horaColegiado;
  } else if (field === "hora_coordinacion" && !isNaN(horaCoordinacion)) {
    cantidad -= horaCoordinacion - prevHoraCoordinacion;
    this.prevHoraCoordinacion = horaCoordinacion;
  } else if (field === "hora_libre" && !isNaN(horaLibre)) {
    cantidad -= horaLibre - prevHoraLibre;
    this.prevHoraLibre = horaLibre;
  }

  // Asegurarse de que la cantidad no se vuelva negativa
  cantidad = Math.max(cantidad, 0);

  // Calcular el total de horas como la suma de cantidad, horaAtencion, horaTutoria, horaColegiado, horaCoordinacion y horaLibre
  let totalHoras = cantidad + horaAtencion + horaTutoria + horaColegiado + horaCoordinacion + horaLibre;

  // Asignar las nuevas horas
  this.cantidad = cantidad;
  this.horas_totales = totalHoras;
},

  },
};
</script>

<style>
.ag-grid-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 50%;
  height: 50vh;
}

.error-message {
  color: red;
}

.horario-container {
  margin-bottom: 20px;
  /* Espacio entre cada bloque de horario */
}

.horario-label {
  font-weight: bold;
  margin-bottom: 20px;
  /* Espacio entre la etiqueta y la tabla */
  display: block;
  /* Asegura que la etiqueta esté en su propia línea */
  text-align: right;
  /* Alinea la etiqueta a la derecha */
}
</style>
